import { render, staticRenderFns } from "./UpcomingEventShort.vue?vue&type=template&id=245580fb&"
import script from "./UpcomingEventShort.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventShort.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventShort.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VProgressCircular,VRow,VTab,VTabItem,VTabs})
